import React, { useContext } from "react";
import { AppContext } from "../../store/AppContext";
import ViewCustomer from "./ViewCustomer/ViewCustomer";
import Customers from "./Customers/Customers";

const CustomersTab = () => {
  const { customerTabInfo, selectedTab } = useContext(AppContext);

  console.log("=======>customer2", selectedTab);

  return (
    <>
      {customerTabInfo?.viewCustomer || customerTabInfo?.selectedCustomer ? (
        <ViewCustomer />
      ) : (
        <Customers />
      )}
    </>
  );
};

export default CustomersTab;
